import { ApiRequestStatus } from '@makemydeal/dr-shared-types';
import type { DealProposalState } from './types';

export const getInitialDealProposalState = (): DealProposalState => ({
    deals: undefined,
    printConfig: undefined,
    requestStatus: ApiRequestStatus.Idle,
    isError: false,
    errorMessage: undefined
});
